import { useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { resourceIsCurrent } from '../../utils'

export function useResourcesByDate(){
  const [dates , setDates ] = useState([])
  const [resourcesSortedByDate, setResourcesSortedByDate] = useState([])
  const { date, view } = useSelector(state=>state.dateFilter)
  const { resources, isFetchingResources} = useFetchResources()

  useEffect( () => {
    let start = moment(date).startOf(view)
    let end = moment(date).endOf(view)
    if (view == 'month') {
      // we want to do this so we include the end of previous month and beginning of next month
      start = start.startOf("week")
      end = end.endOf("week")
    }
    let times = end.diff(start, 'days')
    let newDates = [start.format("YYYY-MM-DD")]
    for(var i=0; i < times; i++){
      newDates.push(moment(newDates[newDates.length - 1]).add('1', 'days').format('YYYY-MM-DD'))
    }
    setDates(newDates)
    setResourcesSortedByDate(newDates.map( date => {
      let dateMoment = moment(date)
      let dayAfterDateMoment = moment(date).add('1', 'days')

      return ({
        date,
        resources: resources.filter(resource => {
          let eventAnchorDateMoment = moment(resource.anchor_date)
          return eventAnchorDateMoment.isSameOrAfter(dateMoment) && eventAnchorDateMoment.isBefore(dayAfterDateMoment)
      })
    })}))

  }, [date, resources] )

  return { dates, currentDate: date, resourcesSortedByDate, isFetchingResources }
}


export function useFetchResources(){
  const [resources, setResources ] = useState([])
  const [ filter, setFilter ] = useState({})
  const [ isFetchingResources, setFetchingResources ] = useState(true)
  const { selected, organization, dateFilter } = useSelector(state=>state)
  const { view, date } = dateFilter
  const dispatch = useDispatch()

  useEffect(()=>{
    let filterDate = moment(date)
    if (view == 'agenda'){
      setFilter({
        from: filterDate.startOf('day').format("YYYY-MM-DD"),
        to: filterDate.add(1, 'days').format("YYYY-MM-DD")
      })
    } else if (view == 'week') {
      setFilter({
        from: filterDate.startOf('week').format("YYYY-MM-DD"),
        to: filterDate.endOf('week').add(1, 'days').format("YYYY-MM-DD")
      })
    } else if (view == 'month') {
      setFilter({
        from: filterDate.startOf('month').format("YYYY-MM-DD"),
        to: filterDate.endOf('month').add(1, 'days').format("YYYY-MM-DD")
      })
    }
  }, [date])

  useEffect(()=>{
    if ( !!date && !!view && !!selected.id && !!selected.resource_type && !!filter.from && !!filter.to ){
      setFetchingResources(true)
      $.ajax({
        url: `/organizations/${organization.name}/agenda/resources.json?resource_type=${selected.resource_type}&resource_id=${selected.id}&from=${filter.from}&to=${filter.to}&view=${view}`,
        success: payload => {
          view == 'agenda' ? dispatch({ type: "LOAD_RESOURCES", payload: todaysResources(payload, date) }) : setResources(currentResources(payload))
          setFetchingResources(false)
        }
      })
    }
  },[filter, view, selected.id, selected.resource_type])

  return { resources, isFetchingResources }
}

const todaysResources = (resources, date) => (
  { [date]: resources.filter(resource => moment(resource.anchor_date).isBefore(moment(date).endOf('day'))) }
)

const currentResources = ( resources ) => (
  resources.filter(resource => resourceIsCurrent(resource) )
)
